import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
let contentful = require('contentful')
const contentClient = contentful.createClient({
    space: process.env.REACT_APP_CONTENTFUL_SPACE_TOKEN!,
    accessToken: process.env.REACT_APP_CONTENTFUL_ACCESS_TOKEN!
});
root.render(
  <React.StrictMode>
    <App contentClient={contentClient}/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
